import styled from '@emotion/styled';

/**
 * The container for the whole table. Equivalent to a `<table>` in standard HTML tags.
 * @private
 */
const TableWrapper = styled.div`
  border: 1px solid black;
`;

export { TableWrapper };
